import { metaPath } from 'util/metaPath'
import { createValidator, required } from 'util/validation'
import {
  validateForcaMuscularMao,
  validateForcaMuscularMaoRange,
} from 'view/atendimentos/components/MedicoesPanel/validator-forcaMuscularMao'

import { validateDataMedicaoAnterior } from '../validator-medicaoAnterior'
import { MedicaoAnteriorExameFisicoFormModel } from './model-medicaoAnteriorExameFisico'

const path = metaPath<MedicaoAnteriorExameFisicoFormModel>()

export const medicaoAnteriorExameFisicoValidator = (dataNascimentoCidadao: LocalDate, dataAtendimento: Instant) =>
  createValidator<MedicaoAnteriorExameFisicoFormModel>(
    {
      data: [required],
      valorForcaMuscMaoDireita: [validateForcaMuscularMaoRange],
      valorForcaMuscMaoEsquerda: [validateForcaMuscularMaoRange],
    },
    (values, errors) => {
      if (values?.data && !values?.valorForcaMuscMaoDireita && !values?.valorForcaMuscMaoEsquerda)
        errors.error = 'Pelo menos uma das medições deve ser preenchida.'

      errors.data = validateDataMedicaoAnterior(values?.data, dataAtendimento, dataNascimentoCidadao) || errors.data

      validateForcaMuscularMao(values, errors, path.valorForcaMuscMaoDireita, path.unidadeForcaMuscMaoDireita)
      validateForcaMuscularMao(values, errors, path.valorForcaMuscMaoEsquerda, path.unidadeForcaMuscMaoEsquerda)

      return errors
    }
  )
